import Contact from "../../Contact";
import ActionsButton from "../ActionButton";

const GetInTouch = () => {
  return (
    <section className="  mt-[100px] md:mt-[180px] lg:mt-[274px] text-center lg:text-start container mx-auto lg:space-y-[276px] md:space-y-[100px] space-y-16 lg:pb-[calc(276px-118px)]">
      <div className=" flex flex-col lg:flex-row items-center lg:gap-2 gap-7 md:gap-[80px]">
        <div className="max-w-[824px] space-y-[52px]">
          <div className=" space-y-1">
            <h4 className="font-bold  text-light text-xs ">Get in Touch</h4>
            <div className="space-y-4">
              <h2 className="  lg:text-[74px] md:text-[42px] text-[32px] font-medium lg:leading-[90px]  ">
                Let's Work <span className="text-[#433CAE]">Together </span>
              </h2>
              <p className="!text-[#6D6D6D] text-center lg:text-start  mx-auto   md:px-0 text-lg lg:text-[21px] text-[14px] sm:text-[14px] font-medium   ">
                Ready to transform your brand's digital presence and unlock the
                full potential of social media marketing? Reach out today, and
                let's start crafting your success story together.
              </p>
            </div>
          </div>
          <ActionsButton className="justify-center lg:justify-start " />
        </div>
        <img
          width={582}
          height={437}
          src="/get-in-touch.png"
          alt="get in touch"
        />
      </div>
      <Contact />
    </section>
  );
};

export default GetInTouch;
